import { Asset, GSplatData } from 'playcanvas'

let assetId = 0

export function loadGsplat(assets, assetSource) {
  const contents = assetSource.contents && (
    assetSource.contents instanceof Response
      ? assetSource.contents
      : new Response(assetSource.contents)
  )
  const file = {
    url: contents ? `local-asset-${assetId++}` : (assetSource.url || assetSource.filename),
    filename: assetSource.filename,
    contents
  }
  const data = {
    // SOG already stores GPU-ready textures. Keeping it compressed avoids a
    // costly CPU readback/decompression pass on mobile WebViews.
    decompress: !String(assetSource.filename || assetSource.url || '').toLowerCase().endsWith('.sog'),
    reorder: !(assetSource.animationFrame || false)
  }
  const options = {
    mapUrl: assetSource.mapUrl,
    minimalMemory: assetSource.minimalMemory === true
  }

  return new Promise((resolve, reject) => {
    const asset = new Asset(assetSource.filename || assetSource.url, 'gsplat', file, data, options)
    asset.on('load:data', (gsplatData) => {
      if (gsplatData instanceof GSplatData && gsplatData.getProp('scale_0') && gsplatData.getProp('scale_1') && !gsplatData.getProp('scale_2')) {
        const scale2 = new Float32Array(gsplatData.numSplats).fill(Math.log(1e-6))
        gsplatData.addProp('scale_2', scale2)
      }
    })
    asset.on('load', () => resolve(asset))
    asset.on('error', (error) => {
      assets.remove(asset)
      asset.unload()
      reject(error)
    })
    assets.add(asset)
    assets.load(asset)
  })
}
